// extracted by mini-css-extract-plugin
export default {"cls1":"Avatar-cls1___213e234d2ea4e4e5776","cls2":"Avatar-cls2___189aae43baa38646e98 Avatar-cls1___213e234d2ea4e4e5776"};